module.exports = __webpack_public_path__ + "static/media/Illus-Outpost_1.5a9b5234.png";